import { useWindowSize } from "@hooks/useWindowSize";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { useDetectAdBlock } from "adblock-detect-react";

import PrestitialAd from "./PrestitialAd";

export type PrestitialAdWrapperProps = {
  isPrestitialEnabled: boolean;
  slot: string;
  topOverlayImpressions: number;
};

export default function PrestitialAdWrapper({
  isPrestitialEnabled,
  slot,
  topOverlayImpressions,
}: PrestitialAdWrapperProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const adBlockDetected = useDetectAdBlock();
  const { isScreenMD } = useWindowSize();

  console.log("inside prestital ad wrapper component"); // eslint-disable-line no-console

  return (
    <>
      {OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER &&
      isPrestitialEnabled &&
      isScreenMD &&
      !adBlockDetected ? (
        <PrestitialAd
          slot={slot}
          topOverlayImpressions={topOverlayImpressions}
          adBlockDetected={adBlockDetected}
        />
      ) : null}
    </>
  );
}
